import { useEffect, useState } from "react";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { toastSuccess } from "../../../components/base/Toast";
import Form from "../../../components/form/Form";
import TextBox from "../../../components/form/TextBox";
import { useHub, useJobSources } from "../../../core/Global";
import User from "../models/User";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import ModalUpdateJobRates from "../../../components/modals/ModalUpdateJobRates";
import Tagify from "../../../components/tagify/Tagify";
import { queue } from "jquery";


type TagifyItem = {
    value: string;
    title: string;
};


type Props = {
    userId?: string
    model?: User
    onUpdate?: (user: User) => void
}

export default function CallAccessExtensionAndQueues(props: Props) {

    const hub = useHub();
    const [working, workingSet] = useState<boolean>(false)
    const jobSources = useJobSources()
    const [extensions, setExtensions] = useState<TagifyItem[]>([]);
    const [queues, setQueues] = useState<TagifyItem[]>([]);

    // Sources are FreePBX inbound-route DIDs (phone numbers). We capture the raw array from
    // Tagify's onChange (values are the DIDs; the friendly Description is only shown, not stored).
    const [sourceDescrs, setSourceDescrs] = useState<string[]>(props.model?.accessSourceDescrs ?? []);


    const fetch = () => {
        hub.Get(API_ROUTES.Extensions, res => {
            if (res.success) {
                const list = res.data?.data ?? res.data ?? [];

                const mapped = list.map((x: any) => ({
                    value: x.id,
                    title: x.name
                }));

                setExtensions(mapped);
            }
        });

    
};

// const fetchQueues = () => {
//         hub.Get(API_ROUTES.Queues, res => {
//             if (res.success) {
//                 const list = res.data?.data ?? res.data ?? [];

//                 const mapped = list.map((x: any) => ({
//                     value: x.id,
//                     title: x.queueNumber+"-"+x.name
//                 }));

//                 setQueues(mapped);
//             }
//         });
// }

    // const fetch = () => {
    //     hub.Get(API_ROUTES.Extensions , res => {
    //         if (res.success) console.log("Radmehrtrrrr"+res.data);
    //     })
    // }

    useEffect(() => {
        // fetch();
        // fetchQueues();
    }, [])

    console.log("accessQueueIds:", props.model?.accessQueueIds);
    console.log("accessExtensionsIds:", props.model?.accessExtensionsIds);


    return (
   <Form id="user-techsetting-details-form" className="form"
            onSubmit={(body, callback) => {

                workingSet(true);

                const toStringArray = (value: any): string[] => {
                    if (!value) return [];

                    if (Array.isArray(value)) return value;

                    return value
                        .split(",")
                        .map((x: string) => x.trim())
                        .filter(Boolean);
                };

                hub.Put("/accounts/technicians/updatecallaccess", {
                    ...body,
                    id: props.userId,
                    accessQueueIds: toStringArray(body.accessQueueIds),
                    accessExtensionsIds: toStringArray(body.accessExtensionsIds),
                    accessSourceDescrs: sourceDescrs,
                }, res => {
                    if (res.success) {
                        toastSuccess("Technician Call Access has been updated successfully!");
                        if (props.onUpdate) props.onUpdate(res.data);
                    }
                    workingSet(false);
                })

            }}>
            <div className="card mb-5 mb-xl-10">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">Technician Call Access</h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    :
                                    <>
                                        Update Technician
                                    </>
                            }
                        </button>
                    </div>
                </div>

         
                {
                    <div className="card-body border-top p-9"
                        style={{
                            maxWidth: 1000
                        }}>

                            <Tagify
                                id="tagify-tech-queues"
                                name="accessQueueIds"
                                label="Queues"
                                marginBottom={5}
                                apiUrl={API_ROUTES.TagifyQueues}
                                selectedIds={props.model?.accessQueueIds}
                            />

                            <Tagify
                                id="tagify-tech-extensions"
                                name="accessExtensionsIds"
                                label="Extensions"
                                marginBottom={5}
                                apiUrl={API_ROUTES.TagifyExtensions}
                                selectedIds={props.model?.accessExtensionsIds}
                            />

                            <Tagify
                                id="tagify-tech-sources"
                                name="accessSourceDescrs"
                                label="Sources"
                                marginBottom={5}
                                apiUrl={API_ROUTES.TagifyCallSources}
                                selectedIds={props.model?.accessSourceDescrs}
                                onChange={setSourceDescrs}
                            />

                    </div>
                }


            </div>
        </Form>
        )

}
